import React from 'react';
import Select from 'react-select';
import { Form } from 'react-bootstrap';

const DEFAULT_STYLES = {
	container: (provided) => ({
		...provided,
		minHeight: '30px!important',
		boxShadow: 'none',
	}),
	control: (provided) => ({
		...provided,
		height: '30px!important',
		border: 0,
		boxShadow: 'none',
		backgroundColor: '#E6E6E6',
	}),
	option: (provided, state) => ({
		...provided,
		color: state.isSelected ? 'white' : 'black',
		backgroundColor: state.isSelected ? 'var(--primaryColor)' : 'white',
		'&:hover': {
			backgroundColor: state.isSelected ? 'var(--primaryColor)' : 'var(--secondaryColor)',
		},
		cursor: 'pointer',
	}),
};

// Matches the 34px / 7px-radius / border-strong controls used by EntityList
// pages (see components/EntityList/FormKit.js `controlClass`). Only takes
// effect where entity-list.css is loaded (inside an `.entity-list-page`).
const ENTITY_STYLES = {
	container: (provided) => ({
		...provided,
		minHeight: '34px',
		boxShadow: 'none',
	}),
	control: (provided, state) => ({
		...provided,
		minHeight: '34px',
		border: '1px solid var(--tw-color-border-strong, #ced4da)',
		borderColor: state.isFocused ? 'var(--tw-color-accent, #4155bc)' : 'var(--tw-color-border-strong, #ced4da)',
		borderRadius: '7px',
		boxShadow: 'none',
		backgroundColor: 'var(--tw-color-surface, #fff)',
	}),
	option: DEFAULT_STYLES.option,
};

const SelectDropdown = ({
	label,
	items,
	selected,
	onChange,
	name,
	isInFilterForm,
	accountsList,
	disabled = false,
	variant = 'default',
}) => {
	const customStyles = variant === 'entity' ? ENTITY_STYLES : DEFAULT_STYLES;
	const isEntityVariant = variant === 'entity';
	let options;
	if (!accountsList) {
		options = [...items.map((item) => ({ value: item, label: item }))];
	} else {
		options = items;
	}

	const selectedOption = options.find((option) => option.value === selected);
	const displayValue = selectedOption ? selected.value : '';

	return (
		<div>
			{isInFilterForm ? (
				<Select
					size='sm'
					options={options}
					isDisabled = {disabled}
					name={name}
					value={displayValue}
					placeholder={'Todos'}
					onChange={(selectedOption) => {
						onChange({ target: { name, value: selectedOption.value } });
					}}
					styles={customStyles}
					isInFilterForm={isInFilterForm}
				/>
			) : (
				<>
					{!isEntityVariant && <Form.Label>{label}</Form.Label>}
					<Select
						isDisabled = {disabled}
						options={options}
						name={name}
						value={options.find((option) => option.value === selected)}
						placeholder={name === 'duesOptions'?('Elige que hacer con los Datos existentes:'): (`Elige ${label}`)}
						onChange={onChange}
						styles={customStyles}
					/>
				</>
			)}
		</div>
	);
};
export default SelectDropdown;
